import Store from './components/Store.vue';
import ShoppingCart from './components/ShoppingCart.vue';
import ProductDetails from './components/ProductDetails.vue';
import Login from './components/auth/Login.vue';
import About from './components/About.vue';
import OrderReport from './components/OrderReport.vue';

export const routes = [
	{path: '/report/:orgId/:location', component: OrderReport, name: 'report'},
	{path: '/report', component: OrderReport, name: 'report_default'},
	{path: '/product/:id', component: ProductDetails, name: 'product'},
	{path: '/cart/:orgId/:location', component: ShoppingCart, name: 'shoppingcart'},
	{path: '/login', component: Login, name: 'login', onlyGuest: true },
	{path: '/pages/about', component: About, name: 'about'},
	{path: '/:orgId/:location', component: Store, name: 'mainpage'},
	{path: '*', redirect: '/:orgId/:location' }
];